import { createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { fromProfileStatusActions } from '../actions';
import { IProfileStatusRequest, IProfileStatusResponse } from '../models/profile-status.model';

export const profileStatusFeatureKey = 'profileStatus';

export interface ProfileStatusState {
  profileStatusRequest: IProfileStatusRequest | undefined;
  profileStatusResponse: IProfileStatusResponse | undefined;
  profileStatusFailure: IGenericError<ErrorResponse> | undefined;
  loaded: boolean | undefined;
}

export const initialState: ProfileStatusState = {
  profileStatusRequest: undefined,
  profileStatusResponse: undefined,
  profileStatusFailure: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromProfileStatusActions.loadProfileStatus, (state, action) => ({
    ...state,
    profileStatusRequest: action.request
  })),
  on(fromProfileStatusActions.loadProfileStatusSuccess, (state, action) => ({
    ...state,
    profileStatusResponse: action.response,
    loaded: true
  })),
  on(fromProfileStatusActions.loadProfileStatusFailure, (state, action) => ({
    ...state,
    profileStatusFailure: action.error
  }))
);

export const getProfileStatusRequest = (state: ProfileStatusState) => state.profileStatusRequest;
export const getProfileStatusResponse = (state: ProfileStatusState) => state.profileStatusResponse;
export const getProfileStatusFailure = (state: ProfileStatusState) => state.profileStatusFailure;
export const getProfileStatusIsLoaded = (state: ProfileStatusState) => state.loaded;
